import contratacoesRotas from './contratacoes/ContratacoesRotas'
import entregasRotas from './entregas/EntregasRotas'
import finalizacoesRotas from './finalizacoes/FinalizacoesRotas'
import solicitacoesAditivosRotas from './solicitacoesaditivos/SolicitacoesAditivosRotas'
import solicitacoesReaberturasRotas from './solicitacoesreaberturas/SolicitacoesReaberturasRotas'

export default {
    path: 'uabs',
    name: 'Uabs',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [
        contratacoesRotas,
        entregasRotas,
        finalizacoesRotas,
        solicitacoesAditivosRotas,
        solicitacoesReaberturasRotas
    ]
}
